import React, { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import PropTypes from 'prop-types'
import { css, StyleSheet } from 'aphrodite'
import { COLOR_BLACK, COLOR_TURQUOISE__LIGHT } from '../../lib/colors'

function UIUserMenuLink({ text, route, dynamicStyle, contact, ...props }) {
  const location = useLocation()
  const [isActive, setActive] = useState(false)

  useEffect(() => {
    const path = location?.pathname?.substring(
      location?.pathname?.lastIndexOf('/') + 1
    )
    setActive(route === path)
  }, [location])

  return (
    <div className={css(dynamicStyle)}>
      {!contact ? (
        <Link
          className={css(styles.link, isActive && styles.isActive)}
          to={route}
          {...props}
        >
          <p
            className={css(styles.linkText, isActive && styles.linkTextActive)}
          >
            {text}
          </p>
        </Link>
      ) : (
        <a
          className={css(styles.link, isActive && styles.isActive)}
          href={`mailto:${contact}`}
        >
          <p
            className={css(styles.linkText, isActive && styles.linkTextActive)}
          >
            {text}
          </p>
        </a>
      )}
    </div>
  )
}

const styles = StyleSheet.create({
  link: {
    display: 'flex',
    alignItems: 'center',
    textDecoration: 'none',
    width: '100%',
    height: 50,
    fontWeight: 400,
    ':hover': {
      color: COLOR_TURQUOISE__LIGHT,
      fontWeight: 700,
      borderLeftWidth: 5,
      borderLeftColor: COLOR_TURQUOISE__LIGHT,
      borderLeftStyle: 'solid',
      cursor: 'pointer',
    },
  },
  linkText: {
    paddingLeft: 15,
    fontSize: 16,
    color: COLOR_BLACK,
  },
  linkTextActive: {
    color: COLOR_TURQUOISE__LIGHT,
  },
  isActive: {
    color: COLOR_TURQUOISE__LIGHT,
    fontWeight: 700,
    borderLeftWidth: 5,
    borderLeftColor: COLOR_TURQUOISE__LIGHT,
    borderLeftStyle: 'solid',
  },
})

UIUserMenuLink.propTypes = {
  text: PropTypes.string.isRequired,
  route: PropTypes.string.isRequired,
  dynamicStyle: PropTypes.node,
  contact: PropTypes.string,
}

export default UIUserMenuLink
